<template>
	<v-container fluid class = "pa-0 ma-0">
	<v-select 
		dense
		attach 
		outlined
		hide-details
		v-model 		= "info" 
		:items  		= "render_list" 
		:label   		= "$ml.get(info_compt.text)" 
		:multiple 		= "info_compt.multiple"
		:item-value 	= "info_compt.key_list"
		:item-text  	= "info_compt.text_list"
		:placeholder 	= "$ml.get(info_compt.placeholder)"
		@input 		 	= "render_search(info)" 
		v-if 			= "info_compt.type == 'select_searcher'"
    	:menu-props 	= "{closeOnContentClick: false, closeOnClick: false} "
	>
    	<!-- @click 		 		= "$Helper.keyboard_is_active('search', ID_notification, 'text')" -->
		<!-- 
		@keyup.enter = "get_search(selected_tags)" -->
		<template 
			v-slot:selection = " { item, index } " 
			v-if 			 = "info_compt.multiple"
		>
	        <v-chip v-if = "index < 1" x-small>
	         	<span> {{ info_compt && info_compt.text_list ? item[info_compt.text_list] : item }} </span>
	        </v-chip>
	        <span v-show = "index == 1" class  = "grey--text caption">
	          (+{{ info.length - 1 }} others)
	        </span>
      	</template>

    	<template v-slot:prepend-item>
	      	<v-list-item>
	        	<v-list-item-content @click= "$Helper.keyboard_is_active('search', ID_notification, 'text')">	          		
			        <v-text-field 
			        	fixed        	
			        	dense			
			        	outlined
			        	hide-details
			        	v-model 	 		= "search" 
			        	:label		 		= "$ml.get('search')" 
			        	class		 		= "mx-0 pt-0" 
			        	@input 		 		= "v => { search = v }"
			        	prepend-inner-icon  = "mdi-magnify" 
			        ></v-text-field>
			        	<!-- @keyup.enter = "get_search(selected_tags)" -->
			        	<!-- @click 		 = "keyboard_is_active()" -->
			        <!-- <input 
			        	type 	= "" 
			        	name 	= ""
			        	@input 	= "onInputChange"
						:value 	= "input"
						class 	= "input"
						dark
						v-show 	= "false"
			        > -->
		        	<!-- <v-bottom-sheet v-model = "sheet" inset dark>					    
					    <v-sheet 
					    	height = "300px" 
					    	class  = "pa-1"
					    >
				        	<SimpleKeyboard 
					        	@onChange 	= "onChange" 
					        	@onKeyPress = "onKeyPress" 
					        	:input 		= "search" 
					        	:theme 		= "theme"
				        	/>
					    </v-sheet>
				    </v-bottom-sheet>   -->
	            </v-list-item-content>
	        </v-list-item>
	        <v-divider class = "mt-1"></v-divider>
		    <v-list-item v-if="isSelectAll">
		    	<v-list-item-content @click="selectAll()">
		    		<v-list-item-title>
		    			{{$ml.get('select_all')}}
		    		</v-list-item-title>
		    	</v-list-item-content>
		    </v-list-item>
        </template>
    </v-select>
  	<v-text-field 
    	dense			        	
    	outlined
    	hide-details
    	v-model 	 		= "search" 
    	:label		 		= "$ml.get('search')" 
    	:class		 		= "class_search" 
    	prepend-inner-icon  = "mdi-magnify" 
    	@input 		 		= "v => { search = info_compt.uppercase ? v.toUpperCase() : v , render_list }"
    	@click 		 		= "$Helper.keyboard_is_active('search', ID_notification, 'text')"
    	v-else-if	 		= "info_compt.type == 'field_searcher'"
    	@keyup.enter 		= "actions('search_url', search)"
	></v-text-field>
	<!-- append-icon -->
	<input 
    	type 	= "" 
    	name 	= ""
    	@input 	= "onInputChange"
		:value 	= "input"
		class 	= "input"
		dark
		v-show 	= "false"
    >
	</v-container>
</template>
<script>
	import EventBus from '@/event-bus'

	export default {
		name  : 'searcher',
		props : [
			'info_to_component',
			'info_to_list',
			'clear_value',
			'isSelectAll',
		],

		// types searcher
			// field_searcher = > just a field that return a list
			// select_searcher = > return the select item
		data  : () => ({
			info 	  	: {},
			list 	  	: [],
			search 	  	: '',
			info_compt 	: {},
			list_search : [],
			// onInputChange   : '',
			input 			: '',
			keyboard 		: false,
			select_input  	: '',
			ID_notification : 'playback_searcher',
			class_search  	: 'mx-4 pt-1',
			check_is_all 	: false,

		}), // data
		/*
			key 		: 'search',
					text 		: 'search',
					placeholder : 'device',
					list 		: 'list_devices',
					key_list	: 'deviceId',
					text_list 	: 'name',
					type 		: 'select_searcher',
					key_search  : 'name',
					key_search_1 : 'deviceId',
					cols 		: {
						col : 2,
					},
		*/

		created(){
			if (this.info_to_component) {
				this.render_info(this.info_to_component);
			}			
		}, // created

		watch :{ 
			info_to_list : function (val){
				if (val && val.length > 0) {
					this.list = val;
				}
			}, // info to list

			clear_value: function(val){				
				if (val) {
					this.info 			= [];		
					this.check_is_all 	= false;
				}
			}, // info value

		}, //watch

		methods : {
			removeKeyboardTypeListener() {
				if (!this._keyboardTypeListener) {
					return;
				}
				EventBus.$off('keyboard_type' + this.ID_notification, this._keyboardTypeListener);
				this._keyboardTypeListener = null;
			},

			actions(act, item, opt){
				if (act == 'search_url') {
					this.$emit('action_search', item);
				}
			}, // actions

			render_info(item){
				if (item) {
					this.info_compt = item;
					if (item.multiple) {
						this.info = [];
					}
					
					if (this.info_to_list && this.info_to_list.length > 0){
						this.list = this.info_to_list;
					}else{
						console.warn("Not found list to searcher : ", this.info_to_list)
					}
				}else{
					console.warn("No found item for render searcher : ", item);
				}
			}, // render info

			render_search(item){
				if (this.info_compt && this.info_compt.type == 'select_searcher') {
					// console.log("CHECK ITEM search ", item, item.length  , this.render_list.length )
					/*if (item.includes("all") && !this.check_is_all) {
						if (this.info_compt && this.info_compt.key_list) {
							item 				= this.list.map(x => x[this.info_compt.key_list]);
						}else{
							item 				= [ ...this.list ]
						}
						this.check_is_all 	= true;
					}else if (item.length > 0 ) {
						if (item.includes("all")) {							
							this.check_is_all 	= false;
							const indexAll = item.findIndex(x => x == "all");							
							if (indexAll >= 0) {
								item.splice(indexAll, 1);
							}
						}else if (item.length  == this.render_list.length-1){ // this.list
							item = [];
							this.check_is_all 	= false;
						}						
					}
					else{						
						item 		= [];							
					}									*/	
					this.info = item;
					this.$emit("receive_info", item);
				}else if(this.info_compt && this.info_compt.type == 'field_searcher') {
					// console.log("send listed ")
					this.$emit("receive_info", this.list_search);
				}else{
					console.warn("Not found select type for return ", this.info_compt)
				}
			}, // render search
			selectAll(){
				if(this.info_compt?.multiple && this.info_compt.type == 'select_searcher'){					
					if( this.render_list.length == this.info.length){
						this.info=[]
						this.check_is_all=false;
					}else{
						this.info=this.info_compt?.key_list ?this.render_list.map(x => x[this.info_compt.key_list]) : [...this.render_list]
					}
					this.$emit("receive_info", this.info);					
				}
			},

			keyboard_is_active(keys, id_notification, type){
			    let key_board = false;
			    if (localStorage.getItem('virtual_Key_board')) {
			      key_board = JSON.parse(localStorage.getItem('virtual_Key_board'));
			    }       
			    // console.log(key_board , "KEYbOARD ACTIVE ")
			    if (key_board) {              
			      /*if (this[keys]) {
			          this[keys] = '';
			      }*/
			      // keys         
			      EventBus.$emit('active_keyboard_key',{
			        ID   : id_notification,
			        key  : keys,
			        type
			      });
			    }       
			}, // keyboard_is_active

			onInputChange(input){
				// console.log("on input change", input)
				this.input = input.target.value;
			}, // onInputChange
			

		}, // methods

		computed : {
			render_list(){
				let vm 			= this;
				let list_filter = [];
				if (this.search) {
					this.$emit("typing", this.search);
					const searchLower = this.search.toLowerCase();
					
					// Si search_all_columns está activo, buscar en todas las columnas relevantes
					if (vm.info_compt.search_all_columns) {
						list_filter = this.list.filter( item => {
							if (!item) return false;
							
							// Lista de campos a buscar
							const searchableFields = [
								item[vm.info_compt.key_search],
								item[vm.info_compt.key_search_1],
								item.name,
								item.deviceId,
								item.type,
								item.ip,
								item.resolution,
								item.fps_display,
								item.codec,
								item.bitrate_display,
								item.workstation,
								item.limited,
								item.status_text,
								item.status_key
							];
							
							// Buscar en todos los campos
							return searchableFields.some(field => {
								if (field === null || field === undefined) return false;
								return field.toString().toLowerCase().includes(searchLower);
							});
						});
					} else {
						// Comportamiento original: buscar solo en key_search y key_search_1
						list_filter = this.list.filter( item => {
							return item && item[vm.info_compt.key_search] && item[vm.info_compt.key_search].toLowerCase().indexOf(searchLower) > -1;
						});
						if (list_filter.length === 0 && vm.info_compt.key_search_1) {
							list_filter = this.list.filter( item1 => {
								return item1 && item1[vm.info_compt.key_search_1] && item1[vm.info_compt.key_search_1].toLowerCase().indexOf(searchLower) > -1;
							});
						}
					}
				}else{
					list_filter = this.list;
					this.$emit("typing", "");
				}
				vm.list_search = list_filter;
				// console.log(list_filter, "*************** FILTER");
				if (this.info_compt && this.info_compt.type == 'field_searcher') {
					this.$emit('receive_info', list_filter);
				}
				return list_filter;
			}, // render list

		}, // computed

		mounted() {
			this.removeKeyboardTypeListener();
			this._keyboardTypeListener = (action) =>{
				if (action) {
					// console.log("INPUT TYPE : ",action.input)
					if (action.setting) {
						let { obj, key, type } =  action.setting;
						if (type == 'text') {
							this[key] = action.input;
						}else{
							this[obj][key] = action.input;
							
						}
					}
				}
			};
			EventBus.$on('keyboard_type' + this.ID_notification, this._keyboardTypeListener);

		}, // mounted

		beforeDestroy() {
			this.removeKeyboardTypeListener();
		},
	}
</script>
